var _rect, _rect2, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRealizedIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_10771_44916)",
    fillOpacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 15.5,
    stroke: "#0D1A16",
    strokeOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0282 16.5V18.5434H35.1524L33.2002 20.5029L30.0383 17.3281L25.8645 21.5176L27.3038 22.9623L30.0383 20.2175L33.2002 23.3923L36.6762 19.9033V22.207H38.7119V16.5H33.0282ZM16.5 23.6098V42H45V23.6098H42.9643V39.9566H20.5714V23.6098H16.5Z",
    fill: "#02B37F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7679 27.6965C30.8231 27.6965 29.9169 28.0733 29.2488 28.7439C28.5807 29.4145 28.2054 30.324 28.2054 31.2724C28.2054 32.2208 28.5807 33.1303 29.2488 33.8009C29.9169 34.4715 30.8231 34.8483 31.7679 34.8483C32.7127 34.8483 33.6189 34.4715 34.287 33.8009C34.9551 33.1303 35.3304 32.2208 35.3304 31.2724C35.3304 30.324 34.9551 29.4145 34.287 28.7439C33.6189 28.0733 32.7127 27.6965 31.7679 27.6965ZM22.6072 30.2507V32.2941H26.1697V30.2507H22.6072ZM37.3661 30.2507V32.2941H40.9286V30.2507H37.3661Z",
    fill: "#F2AE00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10771_44916",
    x1: 9,
    y1: 2,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealizedIconLight);
export default __webpack_public_path__ + "static/media/realizedIconLight.4f57af5fd09511b5eff5a77fd16d35d6.svg";
export { ForwardRef as ReactComponent };